import { useQuery } from "@tanstack/react-query";
import type { RequestProductsStats } from "../../../products/types";
import api from "../../http";

interface UseGetRequestProductsStatsParams {
    refetchInterval?: number | false;
}

export const useGetRequestProductsStats = ({ refetchInterval = false }: UseGetRequestProductsStatsParams = {}) => {
    const query = useQuery({
        queryKey: ['request-products', 'stats'],
        refetchInterval,
        queryFn: async (): Promise<RequestProductsStats> => {
            const { data } = await api.get<RequestProductsStats>('/request-products/stats');
            return data;
        },
    });

    return query;
};
